import SchoolSecretaryPage from './SchoolSecretaryPage';

export default SchoolSecretaryPage;
